module.exports = __webpack_public_path__ + "img/ski_sub_title2.092c55d4.jpg";